import { render, staticRenderFns } from "./ManageSchemaInput.vue?vue&type=template&id=c52ac90a&"
import script from "./ManageSchemaInput.vue?vue&type=script&lang=js&"
export * from "./ManageSchemaInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports